var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3994 6.5C16.1712 6.5 17.7647 7.57863 18.4229 9.22363L20.1855 13.6309C21.0225 15.7233 20.1162 18.1082 18.1006 19.1162L17.333 19.5C17.333 19.5 18.4167 24.9167 22.75 29.25C27.0833 33.5833 32.5 34.667 32.5 34.667L32.8838 33.8994C33.8918 31.8838 36.2767 30.9775 38.3691 31.8145L42.7764 33.5771C44.4214 34.2353 45.5 35.8288 45.5 37.6006V41.167C45.4998 43.56 43.56 45.4998 41.167 45.5C22.0211 45.5 6.5 29.9789 6.5 10.833C6.50018 8.44003 8.44003 6.50018 10.833 6.5H14.3994ZM41.5996 17.333C43.7535 17.333 45.5 19.0795 45.5 21.2334C45.5 22.6692 44.3361 23.8328 42.9004 23.833H32.9336C31.4977 23.833 30.333 22.6693 30.333 21.2334C30.333 19.0795 32.0795 17.333 34.2334 17.333H41.5996ZM37.917 6.5C40.31 6.50018 42.2498 8.44003 42.25 10.833C42.25 13.2261 40.3101 15.1668 37.917 15.167C35.5238 15.167 33.583 13.2262 33.583 10.833C33.5832 8.43992 35.5239 6.5 37.917 6.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallUser);
export default __webpack_public_path__ + "static/media/call-user.d9813084a6b914de46a8f0d99a935d48.svg";
export { ForwardRef as ReactComponent };